<script>
  import { waitLocale, addMessages, init } from "svelte-i18n";
  import MoreDetails from "./components/MoreDetails.svelte";
  import StarsRating from "./components/StarsRating.svelte";
  import ThankYou from "./components/ThankYou.svelte";
  import { _ } from "svelte-i18n";
  import it from "./locales/it.json";
  import FeedbackOptions from "./components/FeedbackOptions.svelte";

  let BASE_URL = process.env.BASE_URL;

  addMessages("it", it);
  init({
    fallbackLocale: "it",
  });
  export function preload() {
    return waitLocale();
  }

  let step = 1;
  let rating = 0;
  let feedbackSelected = "";
  let showError = false;
  let details = "";
  let contentId = "";
  let pageCode = "";

  function handleBack() {
    step--;

    if (step === 0) {
      rating = 0;
    }
  }

  async function handleNext() {
    if (step === 2) {
      await handleSubmit();
      return;
    }

    if (!showError) {
      step++;
    }
  }

  function getContentId() {
    contentId = document.getElementById("content_id");

    if (contentId) {
      return contentId.textContent.trim();
    }

    return null;
  }

  function getPageCode() {
    pageCode = document.getElementById("page_code");

    if (pageCode) {
      return pageCode.textContent.trim();
    }

    return null;
  }

  async function handleSubmit() {
    const baseUrl = BASE_URL + "/do/jpagidservicerating/Front/rate/save";
    const params = {
      score: rating,
      scoreDetail: feedbackSelected,
      note: details,
    }

    const contentId = getContentId();
    if (contentId !== null) params.contentId = contentId;

    const pageCode = getPageCode();
    if (pageCode !== null) params.pageCode = pageCode;

    await fetch(baseUrl, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(params)
    }).then((res) => {
      if (res.status === 200) {
        step++;
      }
    }).catch(() => console.log(params));
  }

  $: if (rating > 0) {
    step = 1;
  }

  $: showError = feedbackSelected === "";
</script>

<div class="col-12 offset-lg-3 col-lg-6 p-lg-0 px-4">
  <div id="rating" class="cmp-rating">
    <div class="card shadow card-wrapper" data-element="feedback">
      <div class="cmp-rating__card-first {step < 3 ? '' : 'd-none'}">
        <div class="card-header border-0 mb-0">
          <h2 class="title-medium-2-semi-bold" data-element="feedback-title">
            {$_("mainQuestion")}
          </h2>
        </div>
        <div class="card-body">
          <StarsRating bind:rating />
        </div>
      </div>
      <div
        class={rating > 0 && step < 3 && step > 0
          ? "form-rating"
          : "form-rating d-none"}
      >
        <FeedbackOptions
          cssClass={step === 1 ? "active" : "d-none"}
          bind:feedbackSelected
          type={rating <= 3 ? "negative" : "positive"}
        />
        <div class:d-none={!showError} class="alert alert-warning">
          {$_("step1.selectElement")}
        </div>

        <MoreDetails cssClass={step === 2 ? "active" : "d-none"} bind:details />

        <div
          class="d-flex flex-nowrap pt-4 w-100 justify-content-center button-shadow"
        >
          <button
            class="btn btn-outline-primary fw-bold me-4 btn-back"
            on:click={handleBack}
          >
            {$_("buttons.back")}
          </button>
          <button
            class="btn btn-primary fw-bold btn-next"
            on:click={handleNext}
          >
            {$_("buttons.next")}
          </button>
        </div>
      </div>

      <ThankYou cssClass={step === 3 ? "active" : "d-none"} />
    </div>
  </div>
</div>
